import { render, staticRenderFns } from "./ChatPeopleDialog.vue?vue&type=template&id=ba112516&scoped=true"
import script from "./ChatPeopleDialog.vue?vue&type=script&lang=js"
export * from "./ChatPeopleDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatPeopleDialog.vue?vue&type=style&index=0&id=ba112516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba112516",
  null
  
)

export default component.exports